import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyTable',
  props: {
    search: null,
    registryName: null
  },
  emits: ["clear"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'clear'): void
}), expose: any, slots: any, attrs: any }) {

const { search, registryName } = __props as {
	search?: string
	registryName: string
};





const title = computed(() =>
	search ? `Nenhum resultado encontrado para “${search}”` : 'Nenhum registro encontrado',
)

const subtitle = computed(() =>
	search
		? `Tente pesquisar outros termos para obter melhores resultados`
		: `Para começar, clique em “Cadastrar” para criar ${registryName || ''}`,
)

const icon = computed(() =>
	search ? 'streamline:magnifying-glass-solid' : 'fa6-solid:folder-open',
)

return { __sfc: true,emit, title, subtitle, icon, Icon }
}

})